import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-help-sets',
    templateUrl: './help-sets.component.html',
    styleUrls: ['./help-sets.component.css'],
    standalone: false
})
export class HelpSetsComponent implements OnInit {

  // images
  @Input() getImgs: string[] = [];
  @Output() showImg: EventEmitter<string> = new EventEmitter<string>();

  constructor() {

  }

  ngOnInit(): void {

  }

  // show selected image on screen
  showImage(url: string): void {
    this.showImg.emit(url);
  }

}
